/**
 * Registro dos módulos — fonte única, como no sistema atual.
 *
 * Lá é a constante `MODULOS` no Code.gs, e a regra é a mesma: acrescentar um
 * módulo é acrescentar uma linha aqui, e ele aparece no hub, nas permissões e
 * na navegação sem mexer em mais nada.
 *
 * `pronto` marca o que já foi portado. Um módulo não pronto continua listado,
 * mas explica o que falta — esconder daria a impressão de que sumiu, e mostrar
 * uma tela vazia seria pior ainda.
 */

export interface Modulo {
  chave: string;
  nome: string;
  emoji: string;
  descricao: string;
  onde: string;
  pronto: boolean;
  /** O que ainda falta, quando não está pronto. */
  falta?: string;
}

export const MODULOS: Modulo[] = [
  {
    chave: 'desk',
    nome: 'Escritório',
    emoji: '🖥️',
    descricao: 'Estoque, aprovações e romaneios',
    onde: 'Use no computador',
    pronto: true,
  },
  {
    chave: 'master',
    nome: 'Administração',
    emoji: '🛡️',
    descricao: 'Cadastros, log do sistema, erros e correção de saldo (dar este módulo NÃO torna a pessoa master)',
    onde: 'Use no computador',
    pronto: true,
  },
  {
    chave: 'entrada',
    nome: 'Entrada de material',
    emoji: '📥',
    descricao: 'Registrar chegada de material por foto',
    onde: 'Use no celular',
    pronto: true,
  },
  {
    chave: 'motorista',
    nome: 'Motorista',
    emoji: '🚚',
    descricao: 'Retirar e entregar romaneios',
    onde: 'Use no celular',
    pronto: true,
  },
  {
    chave: 'sst',
    nome: 'Segurança do Trabalho',
    emoji: '🦺',
    descricao: 'Exames, afastamentos e pendências de SST de cada funcionário',
    onde: 'Use no computador',
    pronto: true,
  },
  {
    chave: 'pedidos',
    nome: 'Pedidos',
    emoji: '🛒',
    descricao: 'Vitrine para engenharia e compras pedirem material',
    onde: 'Use no computador ou celular',
    pronto: true,
  },
];

export function modulo(chave: string): Modulo | undefined {
  return MODULOS.find((m) => m.chave === chave);
}

/** Só os que a pessoa tem liberados, na ordem do registro. */
export function modulosDe(liberados: string[]): Modulo[] {
  return MODULOS.filter((m) => liberados.includes(m.chave));
}
